module.exports = __webpack_public_path__ + "media/images/country_flags/lt-7aa775cdcd07d20c15203d69ecb310f6.png";